/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useAppContext } from 'src/helpers/app'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from 'src/pages/quiz/contextAPI'
import { budgets, BUDGET_500_INDEX } from '../../Budget/Budget.hook'
import { PATH_URL, REDIRECT_PATH } from 'src/helpers'
import { ColorPalette } from 'src/types'
import { SESSION_NAME_LOCAL } from 'src/helpers/app'
import { QuizType } from 'src/pages/shared'

export const useColorPaletteComponent = () => {
  const history = useHistory()
  const { data, setQuizScreen, quizQuestionData } = useContext(QuizQuestionContext)
  const [paletteSelected, setPaletteSelected] = useState<ColorPalette | undefined>(data.colorPalette)
  const { appData } = useAppContext()
  const query = new URLSearchParams(useLocation().search)
  const quizType = query.get('quizType')

  const handleNext = async () => {
    const skipServiceability = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}').skipServiceability
    if (appData.isMicroWedding) {
      localStorage.setItem(
        'tempPoppySessionData',
        JSON.stringify({
          ...JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}'),
          colorPalette: paletteSelected,
          sessionId: localStorage.getItem(SESSION_NAME_LOCAL),
          budget: +budgets[BUDGET_500_INDEX].value,
        })
      )
    } else {
      localStorage.setItem(
        'tempPoppySessionData',
        JSON.stringify({
          ...JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}'),
          colorPalette: paletteSelected,
          sessionId: localStorage.getItem(SESSION_NAME_LOCAL),
        })
      )
    }

    if (skipServiceability) {
      history.push({ pathname: PATH_URL.YOUR_DETAILS })
      setQuizScreen(SCREEN_QUIZ_QUESTION.YOUR_DETAILS)
    } else {
      history.push({ pathname: PATH_URL.NEW_AVAILABILITY_PAGE })
      setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_AVAILABILITY_PAGE)
    }
  }

  const handleNextWithValue = async (value: ColorPalette) => {
    const skipServiceability = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}').skipServiceability
    setPaletteSelected(value)
    if (appData.isMicroWedding) {
      localStorage.setItem(
        'tempPoppySessionData',
        JSON.stringify({
          ...JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}'),
          colorPalette: value,
          sessionId: localStorage.getItem(SESSION_NAME_LOCAL),
          budget: +budgets[BUDGET_500_INDEX].value,
        })
      )
    } else {
      localStorage.setItem(
        'tempPoppySessionData',
        JSON.stringify({
          ...JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}'),
          colorPalette: value,
          sessionId: localStorage.getItem(SESSION_NAME_LOCAL),
        })
      )
    }

    if (skipServiceability) {
      history.push({ pathname: PATH_URL.YOUR_DETAILS })
      setQuizScreen(SCREEN_QUIZ_QUESTION.YOUR_DETAILS)
    } else if (quizType === QuizType.PINTEREST) {
      history.push({
        pathname: PATH_URL.PLANNING_STAGE,
        search: new URLSearchParams({ quizType }).toString(),
      })
      setQuizScreen(SCREEN_QUIZ_QUESTION.PLANNING_STAGE)
    } else {
      history.push({ pathname: PATH_URL.NEW_AVAILABILITY_PAGE })
      setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_AVAILABILITY_PAGE)
    }
  }

  const handleBack = () => {
    if (window.history.length > 1) {
      history.goBack()
    } else if (quizType === QuizType.PINTEREST) {
      history.push({
        pathname: PATH_URL.PINTEREST_LINK_YOUR_BOARD,
        search: new URLSearchParams({ quizType }).toString(),
      })
      setQuizScreen(SCREEN_QUIZ_QUESTION.PINTEREST_LINK_YOUR_BOARD)
    } else {
      localStorage.setItem('tempPoppySessionData', '{}')
      window.location.href = REDIRECT_PATH.HOME
    }
  }

  const nextDisabled = useMemo(() => !paletteSelected, [paletteSelected])

  useEffect(() => {
    if (!paletteSelected && quizQuestionData?.colorPalettes?.length) {
      const currentTempData = JSON.parse(localStorage.getItem('tempPoppySessionData') || '{}')
      const currentColorPalette = currentTempData?.colorPalette
      if (currentColorPalette) {
        setPaletteSelected(currentColorPalette)
      } else {
        setPaletteSelected(undefined)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizQuestionData?.colorPalettes?.length])

  return {
    colorPalettes: quizQuestionData?.colorPalettes || [],
    nextDisabled,
    handleBack,
    handleNext,
    handleNextWithValue,
    paletteSelected,
    setPaletteSelected,
  }
}
